<template>
  <div
    class="resVideo"
    @click="handlePlay"
  >

    <div class="video_box">
      <video
        ref="resVideo"
        :src="src[0]"
        :poster="src[1]"
        webkit-playsinline="true"
        playsinline=""
        preload="auto"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
      ></video>

    </div>
    <!-- 播放按钮 -->
    <div
      :class="['play_box',{playMedia:!dev}]"
      v-if="playEle"
    >
      <img
        class="play1"
        :src="require('@/assets/img/resVideo/v1.png')"
      >
      <img :src="require('@/assets/img/resVideo/v2.png')">
      <img :src="require('@/assets/img/resVideo/v3.png')">
    </div>

    <!-- 结果组件 -->
    <compass v-if="playEle" />
  </div>
</template>

<script>
import compass from "../compass"; // 结果罗盘组件
import { mapActions } from "vuex";
export default {
  name: "ResVideo",
  components: {
    compass
  },

  data() {
    return {
      // 0碎梦  1血河  2神相  3铁衣  4九灵  5素问  6龙吟
      //  ------ 访问成功！
      //  ------ 访问成功！
      //  ------ 访问成功！
      //  3------ 访问成功！
      //  4------ 访问成功！
      //  5------ 访问成功！
      //  6------ 访问成功！
      videos: [
        // 0碎梦
        [
          // 0 mobile
          {
            src:
              "https://n.v.netease.com/2019/0313/d60f533c1cfe96de1dd1d6d6cf24e3f9.mp4",
            poster: require("@/assets/resVideo/poster/0mobile.jpg")
          },
          // 1 pc
          {
            src:
              "https://n.v.netease.com/2019/0311/d369bfe5cb559cc9defc63be88a5bbf4.mp4",
            poster: require("@/assets/resVideo/poster/0pc.jpg")
          }
        ],
        // 1血河
        [
          // 0 mobile
          {
            src:
              "https://n.v.netease.com/2019/0313/9e171bde4536702c69c5136e81f3c667.mp4",
            poster: require("@/assets/resVideo/poster/1mobile.jpg")
          },
          // 1 pc
          {
            src:
              "https://n.v.netease.com/2019/0311/fd90bd7774a8d8475d3fed4754215593.mp4",
            poster: require("@/assets/resVideo/poster/1pc.jpg")
          }
        ],
        // 2神相
        [
          // 0 mobile
          {
            src:
              "https://n.v.netease.com/2019/0313/be823978f253097d6631b2c03ba3767c.mp4",
            poster: require("@/assets/resVideo/poster/2mobile.jpg")
          },
          // 1 pc
          {
            src:
              "https://n.v.netease.com/2019/0311/c8200bbb9d9902c1bed091e7d2fc7652.mp4",
            poster: require("@/assets/resVideo/poster/2pc.jpg")
          }
        ],
        // 3铁衣
        [
          // 0 mobile
          {
            src:
              "https://n.v.netease.com/2019/0313/c328021ab82ceec2973de6e6e1142681.mp4",
            poster: require("@/assets/resVideo/poster/3mobile.jpg")
          },
          // 1 pc
          {
            src:
              "https://n.v.netease.com/2019/0311/bd52840eca194e1eb3800dd177f154dd.mp4",
            poster: require("@/assets/resVideo/poster/3pc.jpg")
          }
        ],
        // 4九灵
        [
          // 0 mobile
          {
            src:
              "https://n.v.netease.com/2019/0313/29c688d538cdf6c2d9f84f4a69ed0a99.mp4",
            poster: require("@/assets/resVideo/poster/4mobile.jpg")
          },
          // 1 pc
          {
            src:
              "https://n.v.netease.com/2019/0311/2b780b608b02ce03f42804d3283d8fa9.mp4",
            poster: require("@/assets/resVideo/poster/4pc.jpg")
          }
        ],
        // 5素问
        [
          // 0 mobile
          {
            src:
              "https://n.v.netease.com/2019/0313/df4dcc6895c9088d7e708430b2ee41c2.mp4",
            poster: require("@/assets/resVideo/poster/5mobile.jpg")
          },
          // 1 pc
          {
            src:
              "https://n.v.netease.com/2019/0311/41086f1e74023046a6f7cef240f96f6a.mp4",
            poster: require("@/assets/resVideo/poster/5pc.jpg")
          }
        ],
        // 6龙吟
        [
          // 0 mobile
          {
            src:
              "https://n.v.netease.com/2019/0313/4d87681e8f65acb34788d9d33a6ca132.mp4",
            poster: require("@/assets/resVideo/poster/6mobile.jpg")
          },
          // 1 pc
          {
            src:
              "https://n.v.netease.com/2019/0311/a797d919972dc02d279d7dcbee1c1d90.mp4",
            poster: require("@/assets/resVideo/poster/6pc.jpg")
          }
        ]
      ],

      playEle: true // 播放按钮是否显示
    };
  },
  computed: {
    src() {
      return [
        this.videos[this.max][this.dev].src,
        this.videos[this.max][this.dev].poster
      ];
    },
    // 音频对象
    audioObj() {
      return this.$store.state.audioObj;
    },
    // 最终结果
    score() {
      return this.$store.state.score;
    },
    // 结果中最大值的下标
    max() {
      let maxNum = Math.max.apply(null, this.score);
      return this.score.indexOf(maxNum);
    },
    // 是否是手机
    dev() {
      return this.$store.state.dev ? 0 : 1;
    }
  },
  mounted() {
    this.resVideoObjFn(this.$refs.resVideo);
    // 视频播放完成后触发事件
    this.$refs.resVideo.addEventListener("ended", this.handleEnded);

    // 播放音乐
    this.audioObj.play();
  },
  methods: {
    ...mapActions(["lastComFn", "resVideoFn", "resVideoObjFn"]),
    handlePlay() {
      this.playEle = false;
      this.$refs.resVideo.play();
      this.audioObj.pause();
      nie.config.stats.url.add(
        location.host + location.pathname + "/page3/",
        "雷达图页面点击"
      );

      // 测试代码
      // setTimeout(() => {
      //   this.$refs.resVideo.currentTime = 95;
      // }, 2000);
    },
    handleEnded() {
      this.resVideoFn(false);
      this.lastComFn(true);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";
.resVideo {
  @include wh(100%, 100%);
  position: relative;
  .video_box {
    @include wh(100%, 100%);
    @include LTput;
    z-index: 1;
    video {
      @include bgObject;
    }
  }

  .play_box {
    @include wh(1.8rem, 2.66rem);
    @include LTRBcenter;
    left: 60%;
    z-index: 10;
    transform: translate(-50%, -50%);
    img {
      @include wh(100%);
      @include LTput;
    }
  }
  .play1 {
    animation: playBtn 0.8s ease-in-out infinite alternate;
  }
  .playMedia {
    @include LRcenter;
    top: 60%;
    transform: translate(-50%, -50%) rotate(90deg);
  }
}
@keyframes playBtn {
  0% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
</style>


